export const getExamenById = (examenes, examenId) => {
  const examen = Array.isArray(examenes)
      && examenes.find(examen => examen.id === examenId);
  return examen;
};

export const setExamenToEdit = (examenes, examen) => {
  const examenFound = Array.isArray(examenes)
      && examen;
  const examenToEdit = {
    ...examenFound,
    id: examen.id,
    id_academia: examen.id_academia,
    nombre: examen.nombre,
    visible: examen.visible
  }
  return examenToEdit;
};